module.exports = __webpack_public_path__ + "img/person_1.10cb9906.webp";